import React from 'react';
import './chat.css';

/**
 * VoiceInput
 *
 * Microphone icon button. Slotted inside the chat input bar.
 *
 * Props:
 *   voiceState  — 'idle' | 'listening' | 'processing' | 'error'
 *   onClick     — () => void
 */
export default function VoiceInput({ voiceState = 'idle', onClick }) {
  const isListening = voiceState === 'listening';
  const isProcessing = voiceState === 'processing';
  const isError = voiceState === 'error';

  const title = isListening
    ? 'Stop recording'
    : isProcessing
      ? 'Processing…'
      : 'Voice input';

  // Block C: the look is in chat.css (.achat-mic); the pulse respects reduced motion there.
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={isProcessing}
      title={title}
      aria-label={title}
      aria-pressed={isListening}
      className={`achat-mic${isListening ? ' achat-mic--on' : ''}${isError ? ' achat-mic--error' : ''}`}
    >
      {/* Inline microphone SVG, no icon library */}
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        width={isListening ? 20 : 18}
        height={isListening ? 20 : 18}
        fill="none"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
        style={{ display: 'block' }}
        aria-hidden="true"
      >
        {/* Mic body */}
        <rect x="9" y="2" width="6" height="11" rx="3" />
        {/* Arc */}
        <path d="M5 10a7 7 0 0 0 14 0" />
        {/* Stand */}
        <line x1="12" y1="17" x2="12" y2="21" />
        <line x1="9" y1="21" x2="15" y2="21" />
      </svg>
    </button>
  );
}
